import appConfig, { LanguageType } from 'app.config'
import { useTranslation } from 'react-i18next'
import React from 'react'
import './ChangeLanguage.scss'

const ChangeLanguage = () => {
	const { i18n } = useTranslation()

	function changeLanguage(language: string) {
		i18n.changeLanguage(language)
	}

	return (
		<div className="language-container-menu pointer">
			<p className="language-menu "></p>
			{Object.keys(appConfig.languages).map((item, i) => {
				const mainLng = item.split('-')[0]
				return (
					<div
						key={'language-selector-item-' + i}
						className={`language-flag-selector ${
							i18n.language === item ? 'active' : 'inactive'
						}`}>
						<ul
							className="language-selector"
							key={'language-selector-item' + i}
							onClick={() => changeLanguage(item)}>
							<li className={'flags ' + mainLng}></li>
							<li className="flag-text">
								{appConfig.languages[item as LanguageType]}
							</li>
						</ul>
					</div>
				)
			})}
		</div>
	)
}
export default ChangeLanguage